export const tPath = 'alerts.liveANF';
